import request from '@/utils/request';
import { Message } from 'element-ui';
import store from '@/store';
import { BASICURL } from '@/constant';
// import _ from 'lodash'

/**
 * 获取验证码
 */
export const getCode = async (param) => {
  const data = await request({
    baseURL: BASICURL,
    url: '/auth/apiPass/user/code',
    method: 'POST',
    data: param,
  });
  if (!data.success) {
    Message.error(data.message || '获取验证码失败');
    return Promise.reject(new Error(data.message || '获取验证码失败'));
  }
  return data;
};

/**
 * 获取用户授权acctoken
 */
export const getAcctoken = async (param) => {
  // eslint-disable-next-line camelcase
  const { username, password, grant_type } = param;
  const data = await request({
    baseURL: BASICURL,
    // eslint-disable-next-line camelcase
    url: `/auth/oauth/token?username=${username}&password=${password}&grant_type=${grant_type}`,
    method: 'POST',
    headers: { Authorization: 'Basic d3hscy13ZWI6d2ViLXNlY3JldA==' },
  });
  if (!data.success) {
    Message.error(data.message || '用户不存在');
    return Promise.reject(new Error(data.message || '用户不存在'));
  }
  return data;
};

// 验证码获取用户授权acctoken
export const getTelAcctoken = async (param) => {
  const { phoneNumber, phoneCode } = param;
  const data = await request({
    baseURL: BASICURL,
    url: `/auth/oauth/phoneLogin?phoneNumber=${phoneNumber}&phoneCode=${phoneCode}`,
    method: 'POST',
    headers: { Authorization: 'Basic d3hscy13ZWI6d2ViLXNlY3JldA==' },
  });
  if (!data.success && !data.access_token) {
    Message.error(data.message || '用户不存在');
    return Promise.reject(new Error(data.message || '用户不存在'));
  }
  return data;
};

/**
 * 获取用户信息
 */
export const getUserInfo = async () => {
  const data = await request({
    baseURL: BASICURL,
    url: '/auth/user/infoByToken',
    method: 'GET',
    // headers
  });
  if (!data.success) {
    Message.error(data.message || '获取用户信息失败');
    return Promise.reject(new Error(data.message || '获取用户信息失败'));
  }
  return data;
};
